import Axios from "axios";
import {
    SET_PROJECT_BUDGET_LIST,
    UNSET_PROJECT_BUDGET_LIST,
  } from "@/store/mutation-types";
import { getProjectBudgetList , saveUpdateProjectBudget , getProjectBudgetDetailList , saveUpdateProjectBudgetDetail , deleteProjectBudgetDetail , getCostHeadList } from "@/store/api";

// initial state
const state = {
  getProjectBudgetList: [],
  getProjectBudgetDetailList: [],
  getCostHeadList: [],
};

const getters = {
  getProjectBudgetList(state) {
    return state.getProjectBudgetList;
  },
  getProjectBudgetDetailList(state) {
    return state.getProjectBudgetDetailList;
  },
  getCostHeadList(state) {
    return state.getCostHeadList;
  },
};

const mutations = {
  [SET_PROJECT_BUDGET_LIST](state, data) {
    state.getProjectBudgetList = data;
  },
  [UNSET_PROJECT_BUDGET_LIST](state) {
    state.getProjectBudgetList = [];
  },
  SET_PROJECT_BUDGET_DETAIL_LIST(state, data) {
    state.getProjectBudgetDetailList = data;
  },
  UNSET_PROJECT_BUDGET_DETAIL_LIST(state) {
    state.getProjectBudgetDetailList = [];
  },
  SET_COST_HEAD_LIST(state, data) {
    state.getCostHeadList = data;
  },
  UNSET_COST_HEAD_LIST(state) {
    state.getCostHeadList = [];
  },
};

const actions = {
  getProjectBudgetList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProjectBudgetList, data)
        .then(function (response) {
          commit('SET_PROJECT_BUDGET_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PROJECT_BUDGET_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  saveUpdateProjectBudget({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProjectBudget, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  getProjectBudgetDetailList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProjectBudgetDetailList, data)
        .then(function (response) {
          commit('SET_PROJECT_BUDGET_DETAIL_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PROJECT_BUDGET_DETAIL_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  saveUpdateProjectBudgetDetail({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProjectBudgetDetail, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  deleteProjectBudgetDetail({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.get(deleteProjectBudgetDetail, { params: { id } })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  getCostHeadList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCostHeadList, data)
        .then(function (response) {
          commit('SET_COST_HEAD_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_COST_HEAD_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};